import React from 'react';
import * as ReactVirtualized from 'react-virtualized';

import { Grid, LegacyText, makeStyles } from '@gogame/components';

import { useCopyLink } from 'scenes/Campaigns/hooks';

import { TrackingLinksListItem } from './TrackingLinksListItem';

const useStyles = makeStyles((theme) => {
  return {
    item: {
      padding: theme.spacing(0, 2),
      height: '46px',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  };
});

export const TrackingLinksList = ({ data }) => {
  const copyLink = useCopyLink();

  const classes = useStyles();

  const handleCopyLink = (url) => {
    copyLink(url);
  };

  return (
    <React.Fragment>
      <Grid
        alignItems={'center'}
        className={classes.item}
        container
        wrap={'nowrap'}
      >
        <Grid item xs>
          <LegacyText variant={'caption'}>Name</LegacyText>
        </Grid>
        <Grid item>
          <LegacyText variant={'caption'}>Copy URL</LegacyText>
        </Grid>
      </Grid>
      <ReactVirtualized.List
        width={880}
        height={Math.min(data.length, 5) * 46}
        rowCount={data.length}
        rowHeight={46}
        rowRenderer={({ index, key, style }) => {
          return (
            <div key={key}>
              <TrackingLinksListItem
                className={classes.item}
                option={data[index]}
                style={style}
                data={data}
                onCopyLink={handleCopyLink}
              />
            </div>
          );
        }}
      />
    </React.Fragment>
  );
};
